import useGlobalContext from "./useGlobalContext";

const useGetFlightsRankingUrl = () => {
  const { locale } = useGlobalContext();

  return `https://www.booking.com/content/how_we_work.${locale}.html#nov2021_how_we_work_flights_ranking_subheading`;
};

export default useGetFlightsRankingUrl;
